(function () {
  'use strict';

  var STORAGE_KEY = 'ge-recently-viewed-v37';
  var MAX_ITEMS = 12;
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;

  function readHistory() {
    try {
      var history = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      var cutoff = Date.now() - MAX_AGE;
      return Array.isArray(history)
        ? history.filter(function (item) {
            return item && item.handle && item.timestamp > cutoff;
          })
        : [];
    } catch (error) {
      return [];
    }
  }

  function writeHistory(history) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(0, MAX_ITEMS)));
    } catch (error) {
      /* Browsing remains available when storage is blocked. */
    }
  }

  function getSectionData(section) {
    var script = section.querySelector('[data-section-data]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return {};
    }
  }

  function productCardUrl(handle) {
    var root = (window.Theme && window.Theme.routes && window.Theme.routes.root_url) || '/';
    root = root === '/' ? '' : root.replace(/\/$/, '');
    return root + '/products/' + encodeURIComponent(handle) + '?view=recently-viewed&ge_card=v43';
  }

  function loadRecentlyViewedImages(container) {
    if (!container) return;
    container.querySelectorAll('img[data-rimg-template]').forEach(function (image) {
      var template = image.getAttribute('data-rimg-template');
      if (!template) return;
      var source = template.replace('{size}', '512x512');
      image.src = source;
      image.srcset = source;
      image.setAttribute('data-rimg', 'loaded');
      image.style.visibility = image.classList.contains('productitem--image-alternate') ? '' : 'visible';
    });
  }

  function repairMobileRecentlyViewedImages(container) {
    if (!container || !window.matchMedia('(max-width: 719px)').matches) return;
    container.querySelectorAll('[data-recently-viewed-card]').forEach(function (card) {
      var handleNode = card.querySelector('[data-product-handle]');
      var handle = handleNode && handleNode.getAttribute('data-product-handle');
      if (!handle || card.dataset.geMobileImageLoading === 'true') return;
      card.dataset.geMobileImageLoading = 'true';

      var root = (window.Theme && window.Theme.routes && window.Theme.routes.root_url) || '/';
      root = root === '/' ? '' : root.replace(/\/$/, '');
      fetch(root + '/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          if (!product) return;
          var source = product.featured_image || (product.images && product.images[0]);
          if (source && typeof source === 'object') source = source.src;
          if (!source) return;
          source = String(source).replace(/^\/\//, 'https://');
          source += (source.indexOf('?') === -1 ? '?' : '&') + 'width=640';

          var figure = card.querySelector('.productitem--image');
          if (!figure) return;
          var image = figure.querySelector('.productitem--image-primary');
          if (!image) {
            image = document.createElement('img');
            image.className = 'productitem--image-primary';
            figure.appendChild(image);
          }
          image.src = source;
          image.srcset = source;
          image.loading = 'lazy';
          image.style.visibility = 'visible';
          image.setAttribute('data-rimg', 'loaded');
        })
        .catch(function () {
          card.dataset.geMobileImageLoading = 'false';
        });
    });
  }

  function renderSection(section, history) {
    var container = section.querySelector('[data-recently-viewed-container]');
    var panel = section.querySelector('.product-recently-viewed--section');
    if (!container || !panel || container.children.length || !history.length) return;

    Promise.all(history.slice(0, MAX_ITEMS).map(function (item) {
      return fetch(productCardUrl(item.handle), { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (cards) {
      if (container.children.length) return;
      var markup = cards.filter(function (card) {
        return card && card.indexOf('productgrid--item') !== -1;
      }).join('');
      if (!markup) return;

      container.innerHTML = markup;
      panel.classList.remove('hide');
      panel.removeAttribute('hidden');
      loadRecentlyViewedImages(container);
      repairMobileRecentlyViewedImages(container);

      if (window.rimg && typeof window.rimg.watch === 'function') {
        window.rimg.watch(container);
      }
    });
  }

  function init() {
    var dataScripts = document.querySelectorAll('[data-section-type="static-recently-viewed"]');
    if (!dataScripts.length) return;
    var sections = Array.prototype.map.call(dataScripts, function (script) {
      return script.closest('.shopify-section') || script.parentElement;
    }).filter(Boolean);

    var history = readHistory();
    sections.forEach(function (section, index) {
      var data;
      try {
        data = JSON.parse(dataScripts[index].textContent);
      } catch (error) {
        data = getSectionData(section);
      }
      var current = data.recently_viewed_info;
      if (current && current.handle) {
        history = history.filter(function (item) { return item.handle !== current.handle; });
        history.unshift({ handle: current.handle, timestamp: Date.now() });
      }
    });
    writeHistory(history);

    sections.forEach(function (section) {
      var container = section.querySelector('[data-recently-viewed-container]');
      if (!container) return;
      new MutationObserver(function () {
        loadRecentlyViewedImages(container);
        repairMobileRecentlyViewedImages(container);
      }).observe(container, { childList: true, subtree: true });
    });

    window.setTimeout(function () {
      sections.forEach(function (section) {
        renderSection(section, history);
        var container = section.querySelector('[data-recently-viewed-container]');
        loadRecentlyViewedImages(container);
        repairMobileRecentlyViewedImages(container);
      });
    }, 1200);

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-clear-recently-viewed]')) return;
      try { localStorage.removeItem(STORAGE_KEY); } catch (error) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
